import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Download } from 'lucide-react';
import { ICON_STROKE_WIDTH } from '../../constants';

export type AnalyticsExportFormat = 'pdf' | 'excel' | 'csv';

const EXPORT_FORMAT_OPTIONS: ReadonlyArray<{
  format: AnalyticsExportFormat;
  label: string;
}> = [
  { format: 'csv', label: 'CSV' },
  { format: 'excel', label: 'Excel' },
  { format: 'pdf', label: 'PDF' },
];

interface AnalyticsExportMenuProps {
  onExport: (format: AnalyticsExportFormat) => void;
  disabled?: boolean;
}

export default function AnalyticsExportMenu({
  onExport,
  disabled,
}: Readonly<AnalyticsExportMenuProps>) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSelect = (format: AnalyticsExportFormat) => {
    setOpen(false);
    onExport(format);
  };

  return (
    <div
      className="analytics-export-wrap"
      ref={wrapRef}
    >
      <button
        type="button"
        className="analytics-export-primary-btn"
        onClick={() => setOpen(v => !v)}
        disabled={disabled}
      >
        <Download
          size={16}
          strokeWidth={ICON_STROKE_WIDTH}
        />
        Export
        <ChevronDown
          size={14}
          strokeWidth={ICON_STROKE_WIDTH}
        />
      </button>
      {open ? (
        <div className="analytics-export-menu">
          {EXPORT_FORMAT_OPTIONS.map(({ format, label }) => (
            <button
              key={format}
              type="button"
              onClick={() => handleSelect(format)}
            >
              {label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
